import React from 'react';
import {
  PendingPropertyIndicator,
  ProgressBarContainer,
  PropertyIndicatorLabel,
  PropertyIndicatorContainer
} from './utils';
import { PlatformBuyIcon } from '../../layout/nav-icons';
import { formatMetricPercentage } from '../../display/hero-metrics';
import { isNil } from 'lodash';

type Props = {
  percentValue: number | null | undefined;
};

export function PercentCompletedIndicator({ percentValue }: Props) {
  if (isNil(percentValue)) {
    return (
      <PendingPropertyIndicator
        label={
          <div className="flex items-center gap-2">
            Pending
            <PlatformBuyIcon />
          </div>
        }
      />
    );
  }

  const value = percentValue * 100;

  return (
    <PropertyIndicatorContainer className="bg-gray-100">
      <PropertyIndicatorLabel className="text-gray-800">
        {formatMetricPercentage(percentValue)}
      </PropertyIndicatorLabel>
      <ProgressBarContainer>
        {value > 100 ? (
          <>
            <div
              className="rounded-l-[3px] bg-gray-500"
              style={{
                width: `${100 - ((value - 100) / value) * 100}%`
              }}
            />
            <div
              className="progress-bar-over-allocated-shadow bg-linear-to-r rounded-r-[3px] from-[#FBBF24] to-[#CA8A04]"
              style={{
                width: `${((value - 100) / value) * 100}%`
              }}
            />
          </>
        ) : (
          <div className="h-1 rounded-[3px] bg-gray-500" style={{ width: `${value}%` }} />
        )}
      </ProgressBarContainer>
    </PropertyIndicatorContainer>
  );
}
